import React, { useRef, useEffect } from 'react';

const networks = [
  { code: 'ET', name: 'Ethio Telecom' },
  { code: 'KE', name: 'Safaricom' },
  { code: 'GH', name: 'MTN Ghana' },
  { code: 'GH', name: 'Telecel' },
  { code: 'GH', name: 'AirtelTigo' },
  { code: 'NG', name: 'MTN Nigeria' },
  { code: 'NG', name: 'Airtel Nigeria' },
  { code: 'NG', name: 'Glo' },
  { code: 'NG', name: '9mobile' },
];

const SupportedNetworks: React.FC = () => {
  const stripRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const strip = stripRef.current;
    if (!strip) return;

    const DURATION_MS = 22000;
    let rafId: number;
    let x = 0;
    let halfWidth = 0;
    let lastTime = 0;

    const tick = (now: number) => {
      if (lastTime === 0) lastTime = now;
      const delta = now - lastTime;
      lastTime = now;
      x -= (halfWidth / DURATION_MS) * delta;
      if (x <= -halfWidth) x += halfWidth;
      strip.style.transform = `translate3d(${x}px,0,0)`;
      rafId = requestAnimationFrame(tick);
    };

    const start = () => {
      halfWidth = strip.scrollWidth / 2;
      rafId = requestAnimationFrame(tick);
    };

    rafId = requestAnimationFrame(start);
    return () => cancelAnimationFrame(rafId);
  }, []);

  return (
    <section className="min-h-screen bg-white flex flex-col items-center justify-center py-20 border-y border-gray-100 overflow-x-hidden">
      <div className="w-full max-w-6xl mx-auto px-5 lg:px-10 flex flex-col items-center text-center">

        <p className="text-xs font-bold tracking-widest text-gray-400 uppercase mb-6">
          Be part of our next big thing
        </p>
        <h2
          className="font-black text-gray-900 leading-tight mb-16"
          style={{ fontSize: 'clamp(2rem, 3.2vw, 3.5rem)' }}
        >
          Supported Countries &amp; Networks
        </h2>
        <p className="text-xs font-bold tracking-widest text-gray-400 uppercase mb-10">
          Connected to leading mobile network operators across Africa.
        </p>

        {/* Marquee clipping wrapper */}
        <div
          className="w-full overflow-hidden mb-20"
          style={{ WebkitTransform: 'translateZ(0)', transform: 'translateZ(0)' }}
        >
          <div
            ref={stripRef}
            style={{ display: 'inline-flex', alignItems: 'center', willChange: 'transform' }}
          >
            {[...networks, ...networks].map((n, i) => (
              <div
                key={i}
                className="flex items-center gap-2.5 flex-shrink-0 rounded-full px-6 py-3"
                style={{ marginRight: '1.25rem', background: '#fff4ed', border: '1px solid #ffe4d3' }}
              >
                <span className="text-[11px] font-black text-white rounded-md w-7 h-6 flex items-center justify-center flex-shrink-0" style={{ background: '#ea3d05' }}>{n.code}</span>
                <span className="text-gray-900 text-sm font-bold whitespace-nowrap">{n.name}</span>
              </div>
            ))}
          </div>
        </div>

        <p className="text-gray-500 text-lg max-w-2xl mx-auto mb-10 leading-relaxed">
          We're making it easier for people to support loved ones back home by buying
          airtime across borders with a simple card payment.
        </p>
        <a
          href="#download"
          className="inline-flex items-center gap-3 transition-colors text-white text-sm font-bold tracking-widest px-8 py-4 rounded-full"
          style={{ backgroundColor: '#ea3d05' }}
        >
          DOWNLOAD APP
          <span className="w-8 h-8 bg-black rounded-full flex items-center justify-center text-white text-base">›</span>
        </a>

      </div>
    </section>
  );
};

export default SupportedNetworks;
